import { isNonEmpty } from '@sgme/fp';
import type { ICellRendererParams } from 'ag-grid-community';
import { UnderlyingTagBase } from 'components/underlying-tag';
import { FC } from 'react';

export const UnderlyingsCellRenderer: FC<ICellRendererParams<unknown, string | undefined>> = ({ value }) => {
  const underlyings: string[] = value?.split(';') ?? [];
  if (underlyings.length === 0) {
    return null;
  }
  return (
    <>
      {underlyings.filter(isNonEmpty).map((underlying, i) => (
        <UnderlyingTagBase key={i} label={underlying} isReadOnly className="me-1" />
      ))}
    </>
  );
};
